import {
  READ_ACTION,
  INVESTMENT_FUNDS_MENU,
  FIXED_INCOME_DAILY_OFFERS_MENU,
} from '@/constants/resources'

export default [
  {
    path: '/investimentos/fundos',
    name: 'investment-funds',
    component: () =>
      import('@/modules/investments/views/InvestmentFundsDataStudio.vue'),
    meta: {
      resource: INVESTMENT_FUNDS_MENU,
      action: READ_ACTION,
      pageTitle: 'Fundos de Investimentos',
    },
  },
  {
    path: '/investimentos/ofertas-diarias-renda-fixa',
    name: 'fixed-income-daily-offers',
    component: () =>
      import('@/modules/investments/views/FixedIncomeDailyOffersDataStudio.vue'),
    meta: {
      resource: FIXED_INCOME_DAILY_OFFERS_MENU,
      action: READ_ACTION,
      pageTitle: 'Ofertas Diárias de Renda Fixa',
    },
  },
]
